
import vClickOutside from 'v-click-outside';

/* Theme set matching */
/* theme value : class name */
const themeSet = {
  'Family_Card_Feature_Tag': 'list-default',
  'Family_Promotion_Tag': 'text-default',
  'Promotion_Tag': 'card-promo',
}

/* Remark: */
/* relatedToParent: */
/* - false (default) = tooltip content relative to label */
/* - true = tooltip content relative to its parent container, need to set 'position: relative' in parent container */
export default {
  name: 'ReusableToolTipWidget',
  directives: {
    clickOutside: vClickOutside.directive,
  },
  props: {
    data: {
      type: Object,
      required: true,
      default: () => {},
    },
    tooltipBelowTag: {
      type: Boolean,
      required: false,
      default: false,
    },
    relatedToParent: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      tooltipActive: false,
      theme: themeSet
    }
  },
  computed: {
    getTheme() {
      return this.data.Theme ? `theme-${themeSet[this.data.Theme]}` : '';
    },
    getPosition() {
      return this.tooltipBelowTag === true ? 'position-bottom' : 'position-top';
    },
    getTooltipActive() {
      return this.tooltipActive ? 'tooltip-active' : '';
    },
    getRelatedToParent() {
      return this.relatedToParent ? 'related-to-parent' : '';
    }
  },
  methods: {
    inactiveTooltipBox() {
      this.tooltipActive = false;
    }
  }

};
